import { render, staticRenderFns } from "./NotClothes.vue?vue&type=template&id=381a536a&scoped=true"
import script from "./NotClothes.vue?vue&type=script&lang=js"
export * from "./NotClothes.vue?vue&type=script&lang=js"
import style0 from "./NotClothes.vue?vue&type=style&index=0&id=381a536a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a536a",
  null
  
)

export default component.exports